import { type ProspectTaskDto } from "@crowdcoursing/api/openapi";
import { Box, Typography } from "@mui/material";

import { TaskCard } from "../TaskCard/TaskCard";

const tNoCompletedTasks = "No completed tasks yet";
const tNoOpenTasks = "No open tasks. Add tasks to track what needs to be done.";
const tNoTasks = "No tasks found";

export interface TaskListProps {
  tasks: ProspectTaskDto[];
  currentUserId?: string | null;
  filter: "all" | "open" | "completed";
  onComplete?: (taskId: string) => Promise<void>;
  onEdit?: (task: ProspectTaskDto) => void;
  onSnooze?: (taskId: string, task: ProspectTaskDto) => Promise<void>;
  onDelete?: (task: ProspectTaskDto) => void;
}

export const TaskList = ({ tasks, currentUserId, filter, onComplete, onEdit, onSnooze, onDelete }: TaskListProps) => {
  return (
    <Box
      display="grid"
      gap={2}
      sx={{
        gridTemplateColumns: {
          lg: "repeat(4, 1fr)", // 4 columns on large screens
          md: "repeat(3, 1fr)", // 3 columns on desktop
          sm: "repeat(2, 1fr)", // 2 columns on tablet
          xs: "1fr", // Full width on mobile
        },
      }}
    >
      {tasks.length > 0 ? (
        tasks.map((task) => (
          <TaskCard
            key={task.id}
            task={task}
            currentUserId={currentUserId}
            onComplete={onComplete}
            onEdit={onEdit}
            onSnooze={onSnooze}
            onDelete={onDelete}
          />
        ))
      ) : (
        <Box sx={{ gridColumn: "1 / -1" }}>
          <Typography color="text.secondary" textAlign="center">
            {filter === "completed" ? tNoCompletedTasks : filter === "open" ? tNoOpenTasks : tNoTasks}
          </Typography>
        </Box>
      )}
    </Box>
  );
};
